export default __webpack_public_path__ + "static/media/calendar.383835a0.svg";